__webpack_require__.p = "https://contract.dev.ma.globalsellingcommunity.cn/";